export interface WorkAttachmentsModel {
    WorkId: string;
    Id: number ;
    Name: string ;
    Type: string ;
    Version: string ;
    ModifiedDate: Date ;
}

export class WorkAttachmentsFrameModel {
    count : number ;
    page : number ;
    pagesize : number ;
    data : WorkAttachmentsModel[] ;
}

export class WorkAttachmentsDtoModel {
    "@odata.context" : number ;
    "@odata.count" : number ;
    value : WorkAttachmentsModel[] ;
}
